export default "__VITE_ASSET__87q3q3j6__"